import * as roomsHelpers from '@/helpers/rooms.js';
import { overlaps } from '@/helpers/utils.js';

const state = () => ({
  initialized: false,
  highscores: [],
  rooms: [],
  room: null,
  phantom: null
});

const getters = {
  placementIsValid: (state) => ({ x, y, cells }) => {
    return !overlaps(state.room.board, cells, x, y);
  },
};

const mutations = {
  setInitialized(state, { initialized }) {
    state.initialized = initialized;
  },
  setHighscores(state, { highscores }) {
    state.highscores = highscores;
  },
  setRooms(state, { rooms }) {
    state.rooms = rooms;
  },
  setRoom(state, { room }) {
    state.room = room;
    roomsHelpers.saveRoom(room);
  },
  setPhantom(state, { phantom }) {
    state.phantom = phantom;
  },
};

const actions = {
  async init({ commit }) {
    let localRoom = roomsHelpers.loadRoom();
    // we don't have a local room to reload
    if (!localRoom) {
      localRoom = roomsHelpers.createRoom();
    }
    // else we can reload the local room directly
    commit("setRoom", { room: localRoom });
    commit("setInitialized", { initialized: true });
  },
  async drawStock({ state, commit }) {
    let room = state.room;
    room = roomsHelpers.drawStock(room);
    commit("setRoom", { room });
  },
  async drawDeck({ commit, state }) {
    let room = state.room;
    room = roomsHelpers.drawDeck(room);
    commit("setRoom", { room });
  },
  async placePiece({ state, commit }, data) {
    let room = state.room;
    room = roomsHelpers.placePiece({ room, data });
    commit("setRoom", { room });
    commit("setPhantom", { phantom: null });
  },
  async undo({ commit, state }) {
    let room = state.room;
    room = roomsHelpers.undo(room);
    if (room !== null) {
      commit("setRoom", { room });
    }
  },
  async redo({ commit, state }) {
    let room = state.room;
    room = roomsHelpers.redo(room);
    if (room !== null) {
      commit("setRoom", { room });
    }
  },
  async setPhantom({ commit }, phantom) {
    commit("setPhantom", { phantom });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
